"use strict";
/*
 * Created on 09.05.2019
 */

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var PromoSettingsValidatorSets_1 = require("../PromoSettingsValidatorSets");
/**
 * Rounding rules settings model
 * @author Tomáš Leity
 *
 * @param volumes
 * @param prices
 * @param percent
 */


var RoundingRulesSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(RoundingRulesSettings, _DomainObject_1$Domai);

  function RoundingRulesSettings(
  /**
   * Rounding rule for Volumes.
   */
  volumes,
  /**
   * Rounding rule for Prices.
   */
  prices,
  /**
   * Rounding rule for Percent.
   */
  percent,
  /**
   * Rounding rule for KPI Prices.
   */
  kpisPrices) {
    var _this;

    _classCallCheck(this, RoundingRulesSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RoundingRulesSettings).call(this));
    _this.volumes = volumes;
    _this.prices = prices;
    _this.percent = percent;
    _this.kpisPrices = kpisPrices;
    return _this;
  }

  return RoundingRulesSettings;
}(DomainObject_1.DomainObject);

exports.RoundingRulesSettings = RoundingRulesSettings;

RoundingRulesSettings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(RoundingRulesSettings.name);
  return {
    volumes: builder.num.apply(builder, ['volumes'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    prices: builder.num.apply(builder, ['prices'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    percent: builder.num.apply(builder, ['percent'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    kpisPrices: builder.num.apply(builder, ['kpisPrices'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators)))
  };
}();